<template>
  <v-card>
    <div class="flex-grow-1 px-2">
      <div class="title-bar d-flex justify-space-between">
        <div>
          <div class="title">
            {{error.business_unit_name}} - {{error.electronic_device_name}} - za leto {{error.year}}
          </div>
          <v-row>
            <v-col cols="4">
              <v-text-field
                placeholder="Številka"
                append-icon="mdi-search"
                v-model.number="number"
                hide-spin-buttons
                hide-details
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                placeholder="Leto (yyyy)"
                append-icon="mdi-search"
                v-model.number="year"
                hide-spin-buttons
                hide-details
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn
                color="#0F998E"
                class="white--text"
                @click="pushMissingInvoice"
              >
                Vstavi
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <!-- <div class="actions">
        </div> -->
      </div>
      <v-card-text>
        <v-row>
          <div class="user-card-label">
            Podjetje
          </div>
          <div class="user-card-value">
            {{error.company_name}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Poslovna enota
          </div>
          <div class="user-card-value">

          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            ID
          </div>
          <div class="user-card-value">
            {{error.business_unit}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            Ime
          </div>
          <div class="user-card-value">
            {{error.business_unit_name}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            Oznaka
          </div>
          <div class="user-card-value">
            {{error.business_premise_id}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Naprava
          </div>
          <div class="user-card-value">

          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            ID
          </div>
          <div class="user-card-value">
            {{error.electronic_device}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            Ime
          </div>
          <div class="user-card-value">
            {{error.electronic_device_name}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            Oznaka
          </div>
          <div class="user-card-value">
            {{error.electronic_device_id}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            Zadnja sinhronizacija
          </div>
          <div class="user-card-value">
            {{lastCommunicationTime | utcToLocal | sloDateTime}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            Platforma
          </div>
          <div class="user-card-value">
            {{appPlatform}}
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label sublabel">
            Verzija
          </div>
          <div class="user-card-value">
            {{version}}
          </div>
        </v-row>
        <v-row v-if="error.inconsistencies.filter(x => x.type === 1).length > 0">
          <div class="user-card-label missing-invoices">
            Manjkajoči računi
          </div>
          <div class="user-card-value">

          </div>
        </v-row>
        <v-row v-for="(inconsistency, i) in error.inconsistencies.filter(x => x.type === 1)" :key="i">
          <div class="user-card-label sublabel">
          </div>
          <div class="user-card-value">
            {{inconsistency.min_invoice_number}}/{{inconsistency.min_invoice_year}} - {{inconsistency.max_invoice_number}}/{{inconsistency.max_invoice_year}}
          </div>
        </v-row>
        <v-row v-if="duplicates.length > 0">
          <div class="user-card-label duplicate-invoices">
            Duplikati računov
          </div>
          <div class="user-card-value">

          </div>
        </v-row>
        <v-row v-if="duplicates.length > 0">
          <div class="user-card-label sublabel">
          </div>
          <div class="user-card-value">
            <v-select
                :items="duplicates"
                v-model="invoice"
                @input="selectedDuplicate"
                label=""
              ></v-select>
          </div>
        </v-row>
      </v-card-text>
    </div>
    <PopupInvoicePreviewDuplicates ref="popupinvoicepreviewduplicate" :invoice="invoice" />
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import PopupInvoicePreviewDuplicates from './PopupInvoicePreviewDuplicates'
export default {
  components: {
    PopupInvoicePreviewDuplicates
  },
  props: {
    error: {
      required: true,
      type: Object
    }
  },
  computed: {
    appPlatform () {
      if (!this.platform) return 'Ni podatka'
      return this.platform === 'win' ? 'Windows' : 'Android'
    },
    duplicates () {
      let duplicates = this.error.inconsistencies.filter(x => x.type === 2)
      if (duplicates.length) {
        return duplicates.sort((a, b) => a.duplicate_invoice_number - b.duplicate_invoice_number).map(x => ({
            text: `${x.duplicate_invoice_number}/${x.duplicate_invoice_year} - ${x.duplicate_count}`,
            value: x
          }))
      } else {
        return []
      }
    }
  },
  data () {
    return {
      number: null,
      year: null,
      device: null,
      lastCommunicationTime: null,
      version: null,
      platform: null,
      invoice: null,
    }
  },
  methods: {
    ...mapActions('invoices', ['createMissingInvoice']),
    ...mapActions('clientsDevices', { loadDevice: 'loadItem' }),
    pushMissingInvoice () {
      this.createMissingInvoice({ electronicDeviceId: this.error.electronic_device, number: this.number, year: this.year })
        .then(() => {
          this.$notify({
            type: 'success',
            text: 'Račun uspešno vstavljen.'
          })
        })
      // console.log({ electronicDeviceId: this.error.electronic_device, number: this.number, year: this.year })
    },
    selectedDuplicate () {
      this.$refs.popupinvoicepreviewduplicate.open(this.error)
    }
  },
  created () {
    // console.log(this.error)
    this.loadDevice({ businessUnitId: this.error.business_unit, childCompanyId: this.error.company, deviceId: this.error.electronic_device })
      .then(a => {
        this.lastCommunicationTime = a.last_communication_time
        this.version = a.app_version
        this.platform = a.app_platform

        if (this.duplicates.length) {
          this.invoice = this.duplicates[0].value
        }
      })
  }
}
</script>

<style lang="scss" scoped>

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
  .v-card {
    padding: 20px;
    &.not-active {
      background-color: #F5F5F5;
      border: 1px solid #EEEEEE;
    }
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
    .actions {
      min-width: 30px;
      max-width: 30px;
      margin-left: 15px;
    }
  }
  .v-card__text {
    padding: 6px 0px 6px 32px;
    .user-card-label {
      min-width: 120px;
      display: inline-block;
      color: #BDBDBD;
      &.sublabel {
        text-align: right;
        padding-right: 22px;
      }
    }
    .user-card-value {
      color: #607D8B;
      font-weight: bold;
      display: inline-block;
      max-width: calc(100% - 150px);
      min-width: 110px;
    }
  }
  .missing-invoices {
    color: #0000ff !important;
    font-weight: bolder;
  }
  .duplicate-invoices {
    color: red !important;
    font-weight: bolder;
  }
  .selectList {
    display: flex;
    outline: none;
  }
</style>
